/**
 * Controller for a list of groups
 * @author Ryan Gladstone, Umer Hassan
 */

function GroupsListController($scope, groupsService, websites, $translate) {
  const allSitesLabel = {
    _id: '',
    display_name: $translate.instant('MULTISITE.ALL_WEBSITES')
  };

  $scope.websites = [allSitesLabel, ...websites];

  groupsService.getGroups()
    .then((data) => {
      $scope.groups = data;
    });

  $scope.filterGroups = (id) => {
    $scope.websiteFilter = $scope.websites.find(website => id === website._id);
  };
}

const arr = [
  '$scope',
  'groupsService',
  'websites',
  '$translate',
  GroupsListController
];

module.exports = (ngModule) => {
  ngModule.controller('GroupsListController', arr);
};
